<template>
  <div>
    <!-- 协议申请表格 -->
    <el-table :data="list.value" border style="width: 100%">
      <el-table-column prop="id" label="id" width="50"></el-table-column>
      <el-table-column prop="name" label="协议名称"></el-table-column>
      <el-table-column prop="version" label="协议版本"></el-table-column>
      <el-table-column show-overflow-tooltip prop="url" label="地址"></el-table-column>
      <el-table-column show-overflow-tooltip prop="remark" label="说明"></el-table-column>
      <el-table-column show-overflow-tooltip prop="larkApprovalCode" label="签报编号"></el-table-column>
      <el-table-column prop="larkApprovalStatus" label="签报状态">
        <!-- (0: 待签报; 1: 已签报) -->
        <template slot-scope="scope">
          <span v-if="scope.row.larkApprovalStatus === 0">待签报</span>
          <span v-if="scope.row.larkApprovalStatus === 1">已签报</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态">
        <!-- (0: 待发布; 1: 已发布 -->
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">待发布</span>
          <span v-if="scope.row.status === 1">已发布</span>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="协议申请人" width="100"></el-table-column>
      <el-table-column prop="updateTime" label="修改时间"></el-table-column>
      <el-table-column prop="publishBy" label="操作人"></el-table-column>
      <el-table-column prop="publishTime" label="发布时间"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_MANAGE_DEL'" v-if="scope.row.larkApprovalStatus === 0"
            type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
          <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_MANAGE_VIEW'" type="text" size="small"
            @click="view(scope.row)">查看</el-button>
          <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_MANAGE_PUBLISH'" v-if="scope.row.larkApprovalStatus === 1 && scope.row.status === 0" type="text" size="small"
            @click="publish(scope.row.id)">发布</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px;" :total="searchParams.total" :current="searchParams.current"
      :size="searchParams.size" :pageSizes="[10, 20, 100]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </ElementPagination>
    <Add ref="addDialog" />
    <Publish ref="publishDialog" />
  </div>
</template>

<script>
import { deleteProtocol } from '@/api/protocolCompliance/protocolManage'
import ElementPagination from '@/components/ElementPagination';
import Message from '@/components/Message'
import Add from './add.vue'
import Publish from './publish.vue'
export default {
  name: 'WebSaaSTable',
  components: {
    ElementPagination,
    Add,
    Publish
  },
  inject: ['searchParams', 'list', 'loadList'],
  provide() {
    return {
      loadList: this.loadList
    };
  },
  data() {
    return {

    };
  },

  methods: {
    //^ ^--------------表格操作栏相关-------------^ ^
    /** 查看的事件 */
    view(row) {
      console.log('查看', row);
      this.$refs.addDialog.show('查看协议', 'view', row);
    },
    /** 删除的事件 */
    deleteRow(row) {
      console.log('删除', row);
      this.$confirm('此操作将永久删除该协议, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteProtocol(row.id)
        console.log('删除接口的响应', data);
        if (data.code === 200) {
          Message.success('删除成功');
          this.loadList();
        }
      }).catch(() => {
        console.log('取消删除');
      });
    },
    /** 发布的事件 */
    publish(id) {
      this.$refs.publishDialog.show(Number(id));
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped></style>